import { FC } from 'react';
import styled, { DefaultTheme } from 'styled-components';

export type BannerImage = {
  success: boolean;
  imageData: string;
};

type BannerStyleParams = {
  theme: DefaultTheme;
  bannerImage?: BannerImage;
};

const bannerStyles = (theme: DefaultTheme, bannerImage?: BannerImage) => {
  const { color, type } = theme;
  const imageStyles =
    bannerImage && bannerImage.success
      ? `background: url(${bannerImage.imageData});`
      : `background: ${color.secondary.light};`;

  return `
    ${imageStyles}
    display: flex;
    justify-content: center;
    align-items:center;
    border-radius: 16px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    font-size: ${type.size.larger};
    line-height: 1.8rem;
    padding: 18px;
    color: ${color.grayscale[1000]};
    font-weight: ${type.weight.bold};
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    font-family: ${type.face};
    width: 100%;
    background-size: cover;
    min-height: 64px;
    background-position: center;
    text-decoration: none;

    &:hover {
      text-decoration: none;
      color: ${color.grayscale[1000]};
    }
  `;
};

const DivWrapper = styled.div(({ theme, bannerImage }: BannerStyleParams) => {
  return bannerStyles(theme, bannerImage);
});

const ButtonWrapper = styled.button(({ theme, bannerImage }: BannerStyleParams) => {
  return bannerStyles(theme, bannerImage);
});

const LinkWrapper = styled.a(({ theme, bannerImage }: BannerStyleParams) => {
  return bannerStyles(theme, bannerImage);
});

export interface IBanner {
  clickCallback?: () => void;
  bannerImage?: BannerImage;
  link?: string;
}

const Banner: FC<IBanner> = ({ clickCallback, children, bannerImage, link }) => {
  return (
    <>
      {clickCallback && (
        <ButtonWrapper onClick={clickCallback} bannerImage={bannerImage}>
          {children}
        </ButtonWrapper>
      )}

      {link && !clickCallback && (
        <LinkWrapper href={link} bannerImage={bannerImage}>
          {children}
        </LinkWrapper>
      )}

      {!clickCallback && !link && <DivWrapper bannerImage={bannerImage}>{children}</DivWrapper>}
    </>
  );
};

export default Banner;
